<template>
  <div class="hero">
    <div class="hero-body">
      <div class="container has-text-centered">
        <WelcomeMessage :msg="message"/>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import WelcomeMessage from '@/components/WelcomeMessage.vue'

export default {
  name: 'Home',
  components: {
    WelcomeMessage
  },
  data() {
    return {
      loginMessage: "Please log in to continue",
      loggedInMessage: "You are logged in"
    }
  },
  computed: {
    isAuthenticated () {
        return this.$store.state.authenticated
    },
    message() {
      if (this.isAuthenticated) {
        return this.loggedInMessage
      } else {
        return this.loginMessage
      }
    }
  }
}
</script>
